// extracted by mini-css-extract-plugin
export default {"form":"TalkSlide_form-UCM","heading":"TalkSlide_heading-eGp","description":"TalkSlide_description-__O"};